import axios from 'axios';

import { AppNoticeAPI } from 'components/appNotices/types';
import { reportSentryError } from 'sentry';

export class AppNotices {
  public data: AppNoticeAPI[] | undefined;

  private userCountry: string | undefined;

  private locale: string | undefined;

  setLocale(locale: string): void {
    this.locale = locale;
  }

  async load(): Promise<AppNoticeAPI[] | undefined> {
    try {
      await this.requestGeoLocation();
      await this.requestAppNotices();
      return this.data;
    } catch (error) {
      return this.handleError();
    }
  }

  async handleError(): Promise<AppNoticeAPI[] | undefined> {
    this.data = [];
    return this.data;
  }

  async requestGeoLocation(): Promise<void> {
    if (this.userCountry) return;
    try {
      const response = await axios.get(`${CONFIG.dinerApiUri}/v2/geolocation`);
      this.userCountry = response.data.country;
    } catch (error) {
      reportSentryError(error, {
        level: 'error',
        extra: {
          query: 'geolocation'
        }
      });
      console.error('Failed to load geolocation');
      throw error;
    }
  }

  async requestAppNotices(): Promise<AppNoticeAPI[] | undefined> {
    if (!this.userCountry || !this.locale) return this.handleError();
    try {
      const response = await axios.post<
        | { app_notices: AppNoticeAPI[]; app_notices_public?: never }
        | { app_notices_public: AppNoticeAPI[]; app_notices?: never }
      >(`${CONFIG.settingsApiUri}/app_notices_public`, {
        app: 'login',
        country: this.userCountry,
        locale: this.locale
      });
      const notices =
        response.data.app_notices || response.data.app_notices_public || [];
      this.data = notices.sort(
        (a, b) =>
          new Date(b.created_at).valueOf() - new Date(a.created_at).valueOf()
      );
    } catch (error) {
      reportSentryError(error, {
        level: 'error',
        extra: {
          query: 'app-notices'
        }
      });
      console.error('Failed to load app notices!');
      throw error;
    }
  }
}

export const appNoticesLoader = new AppNotices();
